import type { ChatMessage, PrescriptionCardPayload, RequestScrollCallback } from '@chewy/chat-library-common';
import { PaginatedSelector } from '@chewy/chat-library-components';
import PrescriptionCardSelectorItem from './PrescriptionCardSelectorItem';

const MAX_PRESCRIPTIONS_PER_PAGE = 3;

interface PrescriptionCardSelectorProps {
  /**
   * Array of prescription items to display
   */
  data: Array<PrescriptionCardPayload>;
  /**
   * Layout direction for the cards
   * @default 'vertical'
   */
  direction?: 'horizontal' | 'vertical';
  /**
   * Chat message associated with the orders
   */
  message?: ChatMessage;
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Callback function to request scrolling to a selected item
   */
  requestScroll?: RequestScrollCallback;
}

/**
 * Displays a paginated list of selectable prescription cards
 */
export default function PrescriptionCardSelector({
  data,
  direction = 'vertical',
  message,
  className,
  requestScroll
}: PrescriptionCardSelectorProps) {
  return (
    <PaginatedSelector
      data={data}
      renderItem={(prescription, index, { ref, handleSelect }) => {
        return (
          <PrescriptionCardSelectorItem
            key={prescription.prescriptionId ?? index}
            ref={ref}
            data={prescription}
            onSelect={() => handleSelect(message?.responseTimestamp)}
            isSelectable={true}
          />
        );
      }}
      direction={direction}
      className={className}
      pageSize={MAX_PRESCRIPTIONS_PER_PAGE}
      itemType="prescription"
      requestScroll={requestScroll}
    />
  );
}
